const deleteProductIDReducer = (state = "", action) => {
    switch(action.type) {
        case 'DELETE_PRODUCT_BY_ID':
            state = action.payload;
            return state;
        default:
            return state;
    }
}

export default deleteProductIDReducer;